import { Dialog, DialogContent, DialogTitle, Grid, makeStyles } from "@material-ui/core"
import React from "react"
import TextFieldPesquisa from "../../../shared/components/TextFieldPesquisa"
import { Typography } from "antd"
import Loading from "../../../shared/components/Loading"
import TabelaListaLaboratorio from "./TabelaListaLaboratorio"
import { FONT_FAMILY_PRIMARY, PRIMARY_COLOR, SECONDARY_COLOR } from "../../../theme";
import Botao from "../../../shared/components/Botao"
import { MENSAGEM_PADRAO_TROCA_LABORATORIO } from "../../../shared/utils/Constantes"

export const ModalTrocaLaboratorio = (props) => {
    const classes = useStyles()

    const tabelaLaboratorios = () => {
        if (props.carregandoDados) {
            return (
                <Grid container alignContent="center">
                    <Loading className={classes.loading} loading={props.carregandoDados} />
                </Grid>
            );
        }
        else if (props.laboratorios?.length > 0) {
            return (
                <TabelaListaLaboratorio
                    laboratorios={props.laboratorios}
                    handleClickLinha={props.handleClickLinha}
                    codigoSelecionado={props.codigoSelecionado}
                />
            );
        } else {
            return props.mensagem;
        };
    }

    const handleChangeTermoBusca = (event) => {
        const novoTermo = event.target.value;
        props.setTermoBusca(novoTermo);
        props.setCodigoSelecionado("");

        if (!novoTermo) {
            props.setLaboratorios([]);
            props.setMensagem(MENSAGEM_PADRAO_TROCA_LABORATORIO);
        }
    };

    return (
        <Dialog
            open={props.modalAberto}
            onClose={props.fecharModal}
            scroll="body"
            maxWidth="md"
            fullWidth
            className={classes.modal}
        >
            <DialogTitle onClose={props.fecharModal} className={`${classes.containerTitulo} pt-6`}>
                <Typography className={classes.titulo} align="left" variant="h6">
                    Selecionar laboratório
                </Typography>
            </DialogTitle>
            <DialogContent className={classes.paddingModal}>
                <Grid item xs={12}>
                    <TextFieldPesquisa
                        id="buscarLaboratorio"
                        label="Pesquisar por código ou laboratório"
                        value={props.termoBusca}
                        onChange={handleChangeTermoBusca}
                        className={classes.inputFiltro}
                        iconeSeparador={false}
                        autoComplete="off"
                    />
                </Grid>
                <Grid container item justifyContent="center" alignItems="center" style={{ height: '18vh', marginTop: '30px', marginBottom: '60px' }}>
                    {tabelaLaboratorios()}
                </Grid>
                <Grid container spacing={2} justifyContent="flex-end">
                    <Grid item align="right">
                        <Botao
                            titulo={"Cancelar"}
                            onClick={props.fecharModal}
                            className={classes.botoes}
                            type="secondary"
                        />
                    </Grid>
                    <Grid item align="right">
                        <Botao
                            titulo={"Trocar"}
                            onClick={() => props.trocarLaboratorio()}
                            className={classes.botoes}
                            disabled={!props.codigoSelecionado}
                            type="primary"
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

const useStyles = makeStyles((theme) => ({
    botoes: {
        width: "113px",
        height: "44px",
        borderRadius: "4px",
        border: "1px"
    },
    modal: {
        overflow: "hidden",
        width: "100%",
        "& .Mui-focused fieldset": {
            borderColor: "#BF43AB !important",
        },
        "& .MuiDialog-paperFullWidth": {
            maxHeight: 'calc(100% - 50px)'
        },
    },
    titulo: {
        color: PRIMARY_COLOR,
        fontWeight: "700",
        fontSize: "24px",
        fontFamily: FONT_FAMILY_PRIMARY

    },
    containerTitulo: {
        textAlign: "center",
        padding: "20px 36px 6px",
    },
    paddingModal: {
        padding: '8px 36px 36px 36px'
    },
    inputFiltro: {
        '& .MuiInputLabel-root': {
            '&.Mui-focused': {
                color: theme.palette.secondary.main + '!important',
            },
        },
    },
    loading: {
        color: SECONDARY_COLOR,
    },
}))
export default ModalTrocaLaboratorio
